<template>
    <div class="container">
        <div class="d-flex justify-content-between">
            <!-- <h3 class="kova-id text-white p-3"> </h3> -->
            <div class="kova-id p-2 text-white font-weight-bolder" style="font-size: 20px">
                {{ test.no }} of {{ test.total }}
            </div>
            <!-- <a-tooltip placement="leftTop">
        <template slot="title">
          <span>If you skip this question, you will get 0 marks for it</span>
        </template>
        <button class="skip px-5 font-weight-bold py-2">
          Skip
        </button>
      </a-tooltip> -->
        </div>

        <div class="bg-light p-2 border add-rounded shadow-sm mt-3">
            <div class="row test-box">
                <div class="col-lg-7 col-sm-12 text-left">
                    <h5 class="font-weight-bolder ml-3 mt-3 mb-0">Question</h5>
                    <div class="questions px-3 my-3 mr-lg-n4">
                        <p class="kova-text">
                            {{ test.QuestionContent }}
                        </p>
                    </div>
                </div>

                <div class="col-lg-5 col-sm-12 mt-lg-5">
                    <div class="answers add-rounded bg-kovatek p-3 mx-3 text-left">
                        <h5 class="text-white">Select your answer</h5>
                        <a-radio-group v-model="answer" v-for="(option, i) in test.OtherAnswers" :key="i">
                            <a-radio class="text-white" :style="radioStyle" :value="option">
                                {{ option }}
                            </a-radio>
                        </a-radio-group>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-3 text-right">
            <button
                @click="$emit('update:show', false)"
                class="font-weight-bolder border-0 text-danger bg-transparent py-2 px-3 mr-3"
            >
                Cancel
            </button>
            <button class="btn-kovatek px-5 py-2 text-size2" v-if="!loading" @click.prevent="submitQuestion(answer)">
                {{ test.no === 10 ? 'Submit' : 'Next' }}
            </button>
            <button class="btn-kovatek px-5 py-2 text-size2" v-else disabled>
                Submitting...
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            answer: null,
            radioStyle: {
                display: 'block',
                height: '45px',
                lineHeight: '45px',
            },
            loading: false,
        };
    },
    props: {
        test: Object,
        testID: [String, Number],
    },
    methods: {
        submitQuestion(answer) {
            if (!answer) return this.showError('No answer selected', 'You must select an option before proceeding');
            const vm = this;

            this.$confirm({
                title: 'Are you sure?',
                content: 'You cannot revert this action!',
                async onOk() {
                    return await submitAnswer();
                },
                onCancel() {},
            });

            async function submitAnswer() {
                vm.loading = true;
                const token = localStorage.getItem('token');
                try {
                    await vm.$api({
                        url: `/tests/${vm.testID}/submit`,
                        method: 'put',
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                        data: {
                            answer,
                        },
                    });

                    vm.showToast('Answer submitted');
                    vm.$emit('next');
                } catch (err) {
                    vm.loading = false;
                    if (err.response) {
                        const { status } = err.response;
                        const message =
                            status === 408
                                ? 'The time for the test has been exceeded'
                                : status === 429
                                ? 'You have finished this test'
                                : 'An error occured';

                        vm.showError(message);
                        vm.$router.push('/skill-score');
                        return;
                    }

                    vm.catchErrors(err);
                }
            }
        },
    },
};
</script>

<style scoped>
.test-box {
    height: 65vh;
}

.questions {
    overflow: hidden;
    overflow-y: auto;
    max-height: 55vh;
}

@media screen and (max-width: 960px) {
    .test-box {
        height: 100vh;
    }
}

.answers {
    height: 90%;
}

.kova-id {
    font-size: 20px;
    width: 100px;
    height: 40px;
}

.kova-text {
    color: #20409a;
}
.icon-size {
    font-size: 25px;
}
.btn-kovatek {
    background-color: #20409a;
    font-weight: bold;
    outline: 0;
    border: 0;
    height: 45px;
    color: #fff;
    border-radius: 30px;
    transition: 0.25s;
    font-size: 18px;
}
.btn-kovatek:hover {
    background-color: #06216d;
    color: #fff;
}
.bg-kovatek {
    background-color: #20409a;
}

.skip {
    background-color: transparent;
    border: solid 1.5px #20409a;
    border-radius: 10px;
    color: #20409a;
    transition: 0.25s;
}

.ant-radio-group {
    display: block !important;
}

.ant-notification {
    top: 85px;
}
</style>
